import React, { useEffect, useRef, useState } from 'react';
import { useNavigation } from '../../utils/redirectUtils';
import { trackPostHogEvent } from '../../utils/posthogUtils';
import Pricing from '../../data/Pricing';
import CyclingText from './CyclingText';
import styles from './NewHero.module.css';
import heroImg from '../../assets/hero-image.webp';

function NewHero() {
    const [isVisible, setIsVisible] = useState(false);
    const [prices, setPrices] = useState(null);
    const elementRef = useRef(null);
    const navigate = useNavigation();
    
    const weightLossPhrases = [
        "Begin with a secure online evaluation",
        "Evidence-informed, medically guided care", 
        "Personalized to your health history and goals",
        "Ongoing support aligned with your lifestyle",
        "Clear guidance on appropriate next steps"
    ];
    
    const handleGetStarted = () => {
        
        // Track submit event
        trackPostHogEvent('landing_page_submitted', {
            selected: 'get_started',
            to_path: '/interview'
        });

        navigate('/interview');
    }

    useEffect(() => {
        const loadPrices = async () => {
            const pricing = Pricing();
            const priceData = await pricing.getPrices();
            setPrices(priceData);
        };
        
        loadPrices();

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            {
                threshold: 0.5,
            }
        );

        let currentElement = elementRef.current;
        if (currentElement) {
            observer.observe(currentElement);
        }
        return () => {
            if (currentElement) {
                observer.unobserve(currentElement);
            }
        };
    }, []);

    return (
        <div 
            className={styles.heroContainer}
            style={{ '--hero-bg-image': `url(${heroImg})` }}
        >
            <section className={styles.hero}>
                <div ref={elementRef} className={styles.heroText}>
                    <div className={styles.heroTopLine + (isVisible ? ' animate__animated animate__fadeInUp' : '')}>
                        <h1 className={styles.heroSafe}>Clinician-Guided GLP-1 Weight Management</h1>
                    </div>
                    <div className={styles.heroWeight + (isVisible ? ' animate__animated animate__fadeInUp' : '')}>
                        <CyclingText phrases={weightLossPhrases} className={styles.cyclingWeight} />
                    </div>
                    <div className={styles.heroJourney + (isVisible ? ' animate__animated animate__fadeInUp' : '')}>
                        Your Journey Starts Here
                    </div>
                    <div className={styles.heroSubtext + (isVisible ? ' animate__animated animate__fadeInUp' : '')}>
                        <div className={styles.bullet}>
                            <div className={styles.check}></div>
                            <span>Complete a brief online clinical evaluation</span>
                        </div>
                        <div className={styles.bullet}>
                            <div className={styles.check}></div>
                            <span>Meet with a licensed clinician via telehealth if required</span>
                        </div>
                        <div className={styles.bullet}>
                            <div className={styles.check}></div>
                            <span>Your clinician determines whether treatment is appropriate</span>
                        </div>
                    </div>
                    <div className={styles.buttonContainer}>
                        <div className={styles.heroButton} onClick={handleGetStarted}>
                            Get Started
                        </div>
                    </div>
                    <div className={styles.secondaryImageContainer}>
                        <img src={heroImg} alt="Hero" className={styles.secondaryHeroImage} />
                    </div>
                </div>
            </section>
        </div>
    );
}

export default NewHero;
